import React from "react";
import { Select } from "./Select";
import { DatepickerRange } from "./Datepicker-reactdates";
import { Counter } from "./Counter";
import additionalfn, { getExtraFieldsRoute } from "../../_additionalfn";
import moment from "moment";
import { LoadingAnimation } from "./LoadingAnimation";
import { CheckBox } from "./CheckBox";
import { Tooltip } from "./Tooltip";
import { ScrollerMobiscroll } from "./ScrollerMobiscroll";
import { SliderMobiscroll } from "./SliderMobiscroll";
import { CurrencyData } from "../Data/ContentData";
import { Modal } from "./Modal";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";
import { fetchExtraFields } from "../api";
import styled from "@emotion/styled";

const MapPopup = styled.div`
  z-index: 5;
`;

const RegionInfoIcon = styled.div`
  width: 20px;
  position: absolute;
  top: 13px;
  right: 30px;
  cursor:pointer;
  & img:hover {
    transform: scale(1.2);
  }
`;

const MapContainer = styled.div`
  top: 5px;
  box-shadow: 0 0 5px 1px #333;
`;

const MapImage = styled.img`
  width: calc(100% - 3px);
  margin-top: 3px;
`;

class SearchFrameComponent extends React.Component {
  constructor(props) {
    super(props);
    const t  = this.props.t;
    const poolWithPrivacyEnabled = this.props.poolWithPrivacyEnabled ;
    this.state = {
      mapOpen: false,
      countryOptions: [],
      iconURL: this.props.searchURLBase ? this.props.searchURLBase : "",
      initial_results: 0,
      modal: null,
      loading: false,
      queryHistory: [],
      queryHistoryIndex: false,
      queryObject: this.props.queryResult
        ? this.queryTokenize(props.queryString)
        : {},
      queryString: props.queryString ? props.queryString : "",
      searchLabel:  props.queryString && props.queryString.length > 0 ? this.showLabel() : t("search"),
      totalResultsCount: props.queryResult
        ? props.queryResult.totalResultsCount
        : false,
      regionOptions: this.getDefaultRegionChoices(),
      maxSleepsOptions: this.getDefaultMaxSleepsChoices()
    };
    if (poolWithPrivacyEnabled) {
      this.poolWithPrivacyRef = React.createRef();
    }
    this.toggleMap = this.toggleMap.bind(this)
  }

  toggleMap() {
    this.setState( prevState => ({
      mapOpen: !prevState.mapOpen
    }));
  }

  componentDidMount() {
    if (!this.props.queryResult && !this.props.hideResults) {
      this.getQuery();
    } else if (!this.props.searchFieldsOnly) {
      // we only need to populate fields
      this.setFields(this.props.queryResult);
    } else {
      // need fields with queryResult empty

      this.getQuery();
    }
    this.loadExtendedFields();

    window.onpopstate = () => {
      window._setters.history.reload();

      const queryHistory = this.state.queryHistory;
      const lastQuery = "";

      for (var i = 0; i < queryHistory.length; i++) {
        if (window.location.href.endsWith(queryHistory[i])) {
          lastQuery = queryHistory[i];
          break;
        }
      }

      this.setState({
        queryString: lastQuery
      });

      this.getFields({
        queryString: lastQuery,
        noHistoryPush: true
      });
    };

    window._setters.history.onpopstateSet = true;

    document.addEventListener("SearchResults_changeQuery", this.updateQuery);
  }
  closeModal = () => {
    this.setState({ 
      modal: null
    });
    this.lastSearch();
  }
  lastSearch = () => {
    this.loading(true);
    if (this.state.lastSuccessfulSearch) {
      const lastSuccessfulSearch = this.state.lastSuccessfulSearch;
      this.setState({
        queryString: lastSuccessfulSearch
      });

      if (this.props.updateURL) {
        additionalfn.updateURL({
          r: this.props.r,
          query: lastSuccessfulSearch,
          sort: additionalfn.getURLParameters("sort", {}),
          page: 1
        });
      }

      this.getFields({ queryString: lastSuccessfulSearch });
      this.loading(false);
    } else {
      this.reset();
    }
  };

  updateQuery = e => {
    this.onChange({
      items: e.detail.items
    });
  };

  additionalResultAction = params => {
    const { t } = this.props;

    switch (params.action) {
      case "display_single":
        var range = params.value.range.split(" -- ");

        if (params.value.total === 0) return null;

        return (
          <div
            key={range[0]} 
            className="mt-2 pointer font-90"
            onClick={() =>
              this.additionalResultAction({
                action: "search",
                items: {
                  stayStart: moment(range[0], "DD-MM-YYYY"),
                  stayEnd: moment(range[1], "DD-MM-YYYY")
                }
              })
            }
          >
            <span className="blue3 font-w600">
              → <span className="underline">{range[0]} - {range[1]}</span>
            </span>&nbsp;
            ({params.value.total}&nbsp;
            {params.value.total > 1 ? t("results") : t("result")})
          </div>
        );
        break;

      case "search":
        this.onChange({
          items: {
            stayStart: params.items.stayStart,
            stayEnd: params.items.stayEnd
          }
        });

        break;

      default:
        break;
    }
  };

  additionalResults = params => {
    const { t } = this.props;
    if (!params.items || params.items.length === 0) return null;

    if (typeof params.items === "object")
      params.items = Object.values(params.items);

    var fakeResult = 0;

    for (var i = 0; i < params.items.length; i++) {
      if (params.items[i].total === 0) fakeResult++;
    }

    if (fakeResult === params.items.length) return null;

    switch (params.action) {
      case "display_list_modal":
        return (
          <div className="mt-3 mb-5">
            <div>{t("other_periods_with_more_availability")}</div>
            <div>
              {params.items.map((item, index) => {
                return this.additionalResultAction({
                  action: "display_single",
                  value: item
                });
              })}
            </div>
          </div>
        );

      default:
        break;
    }
  };

  getFields(params) {
    const route = additionalfn.getSearchRoute({
      r: this.props.r,
      query: params.queryString,
      page: params.page
        ? params.page
        : additionalfn.getURLParameters("page", {
            type: "int",
            defaultValue: 1
          }),
      sort: additionalfn.getURLParameters("sort"),
      perpage: this.props.perpage,
      slideshowImages: this.props.slideshowImages,
      searchURLBase: this.props.searchURLBase
    });

    if (!params.noHistoryPush) {
      const queryHistory = this.state.queryHistory;
      queryHistory.push(params.queryString);

      this.setState({
        queryHistory: queryHistory
      });
    }

    fetch(route, {
      method: "POST"
    })
      .then(response => response.json())
      .then(data => {
        this.setFields(data, true);
        this.setQuery({
          queryString: this.state.queryString,
          queryResult: data
        });
      })
      .catch(() => {
        this.reset();
      });
  }

  loadExtendedFields = async () => {
    const results = await fetchExtraFields(
      getExtraFieldsRoute(this.props.r, this.props.queryString)
    );
    this.setFields(results, true);
  };

  getQuery() {
    this.loading(true);

    if (this.props.initial_query && this.props.initial_query.length > 0) {
      switch (this.props.initial_query) {
        case "search_viewed":
          this.setState({
            queryString: "search_viewed"
          });
          this.getFields({ queryString: "search_viewed" });
          break;
        case "search_favourite":
          this.setState({
            queryString: "search_favourite"
          });
          this.getFields({ queryString: "search_favourite" });
          break;
        default:
          this.setState({
            queryString: this.props.initial_query
          });

          this.getFields({ queryString: this.props.initial_query });
          break;
      }
    } else {
      var defaultQuery = "";

      if (this.props.defaultQuery && parseInt(this.props.page) === 1) {
        defaultQuery = this.props.defaultQuery;

        this.setState({
          queryString: defaultQuery
        });
      }

      this.getFields({ queryString: defaultQuery });
    }
  }

  loading(onoff) {
    const { t } = this.props;
    var searchLabel = onoff ? (
      <LoadingAnimation height="20" searchURLBase={this.props.searchURLBase} style={{height:"20px"}} />
    ) : this.state.queryString.length > 0 ? (
      this.showLabel()
    ) : (
      t("search")
    );

    this.setState({
      searchLabel: searchLabel,
      loading: onoff
    });
  }
  regionChoices(data) {
    if (data.regionChoices) {
      return data.regionChoices
    }
    return data.fields.region;
  }

  getDefaultRegionChoices() {
    if (this.props.queryResult && this.props.queryResult.regionChoices) {
      let regions = additionalfn.key_label_from_value({
        data: this.props.queryResult.regionChoices,
        lowercase_key: true,
        key_space_as_hyphen: true
      });
      return regions;
    }
  }

  getDefaultMaxSleepsChoices() {
    const { t  } = this.props;
    if (this.props.queryResult &&  this.props.queryResult.fields &&  this.props.queryResult.fields.maxSleeps && this.props.queryResult.fields.maxSleeps.choices ) {
      let maxSleeps = additionalfn.labelNumbers({
        data: this.props.queryResult.fields.maxSleeps.choices,
        singular: t("guest"),
        plural: t("guests")
      });
      return maxSleeps;
    }
  }

  setFields(data, withExtended = false) {
    const { t, open } = this.props;

    if (data.fields  && (typeof data.totalResultsCount === 'undefined' || data.totalResultsCount > 0)) {
      this.setState({
        regionOptions: additionalfn.key_label_from_value({
          data: this.regionChoices(data),
          lowercase_key: true,
          key_space_as_hyphen: true
        }),
        maxSleepsOptions: additionalfn.labelNumbers({
          data: data.fields.maxSleeps.choices,
          singular: t("guest"),
          plural: t("guests")
        }),
        totalResultsCount: data.totalResultsCount
      });
      if (withExtended) {
        this.setState({
          poolOptions: additionalfn.key_label_from_value({
            data: data.fields.poolType.choices,
            lowercase_key: true,
            key_space_as_hyphen: true
          }),
          accommodationOptions: additionalfn.key_label_from_value({
            data: data.fields.accommodationType.choices,
            lowercase_key: true,
            key_space_as_hyphen: true
          }),
          cityOptions: additionalfn.key_label_from_value({
            data: data.fields.city.choices,
            lowercase_key: true,
            key_space_as_hyphen: true
          }),
          beachOptions: additionalfn.key_label_from_value({
            data: data.fields.distanceBeach.choices,
            lowercase_key: true,
            key_space_as_hyphen: true
          }),
          numBathrooms: additionalfn.getMinMax({
            data: data.fields.numBathrooms.choices,
            key: "value"
          }),
          numBedrooms: additionalfn.getMinMax({
            data: data.fields.numBedrooms.choices,
            key: "value"
          }),
          youngstersAllowed: data.fields.youngstersAllowed.booleans,
          internet: data.fields.internet.booleans,
          airConditioning: data.fields.airConditioning.booleans,
          dishwasher: data.fields.dishwasher.booleans,
          washingMachine: data.fields.washingMachine.booleans,
          petsAllowed: data.fields.petsAllowed.booleans,
          poolWithPrivacy: data.fields.poolWithPrivacy.booleans,
          seaView: data.fields.seaView.booleans,
        });
      }

      this.setState({
        modal: null,
        lastSuccessfulSearch: this.state.queryString
          ? this.state.queryString
          : null
      });
      if (!withExtended) {
        this.setQuery({
          queryString: this.state.queryString,
          queryResult: data
        });
      }
    } else if (data.totalResultsCount === 0 /*!this.props.searchFieldsOnly */) {
      this.setState({
        modal: (
          <Modal
            key="modal"
            content={
              <div
                className="bg-white p-4 border-radius-default"
                key="modalContent"
              >
                {t("no_results_found")}
                {this.additionalResults({
                  action: "display_list_modal",
                  items: data.additionalResults
                })}
                <div className="mt-4 text-right" key="modalInner">
                  <button
                    key="modalClose"
                    className="btn btn-secondary capitalize"
                    onClick={() => {
                      this.lastSearch();
                    }}
                  >
                    {t("close")}
                  </button>
                </div>
              </div>
            }
            onClose={() => {
              this.lastSearch();
            }}
          />
        )
      });
    }

  }

  queryTokenize = params => {
    var queryTokenized = additionalfn.tokenize(params.queryString);

    for (var i in queryTokenized) {
      if (i === "stayStart" || i === "stayEnd") {
        queryTokenized[i] = moment(
          new Date(
            queryTokenized[i].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
          )
        );
      }
    }

    return queryTokenized;
  };

  setQuery(data) {

    if (data.queryString) {
      data.queryTokenized = this.queryTokenize({
        queryString: data.queryString
      });
    }

    this.setState({
      queryObject: data.queryTokenized ? data.queryTokenized : {},
      queryString: data.queryString
    });
    if (!this.props.queryResult || this.state.initial_results > 0) {
      this.props.onChange(data);
    } else if (this.state.initial_results === 0) {
      this.setState(state => ({
        initial_results: state.initial_results + 1
      }));
    }
    this.loading(false);
  }

  onChange(params) {
    this.setState({mapOpen: false});
    this.loading(true);
    var queryObject = this.state.queryObject;
    for (var i in params.items) {
      if (params.items[i] === null || params.items[i] === undefined) {
        delete queryObject[i];
      } else if (!params.rule) {
        queryObject[i] = params.items[i];
      } else {
        if (params.rule === "not_zero" && params.items[i] === 0) {
          delete queryObject[i];
        } else {
          queryObject[i] = params.items[i];
        }
      }
    }

    for (var i in queryObject) {
      if (i.length === 0) {
        delete queryObject[i];
      }
    }

    this.setState({
      queryObject: queryObject
    });

    const queryObject_clone = { ...queryObject };

    for (var i in queryObject_clone) {
      if (i === "stayStart" || i === "stayEnd") {
        queryObject_clone[i] = queryObject_clone[i].format("DD-MM-YYYY");
      }
    }
    if (queryObject_clone['stayStart'] && !queryObject_clone['stayEnd']) {
      this.loading(false);
      return;
    }
    var queryString = additionalfn.stringify(queryObject_clone);
    this.props.onChange(queryString);
    this.props.onPageChange(1);
    this.setState({
      queryString: queryString
    });

    if (this.props.updateURL) {
      additionalfn.updateURL({
        r: this.props.r,
        query: queryString,
        sort: additionalfn.getURLParameters("sort", {}),
        page: 1
      });
    }

    this.getFields({
      queryString: queryString,
      page: 1
    });
  }

  priceRangeLabel = () => {
    const { t, mobile } = this.props;

    var title = t("select_price_range");

    if (!this.state.queryObject.priceRange) return title;

    var plus = "",
      value = this.priceRangeFormat({
        value: this.state.queryObject.priceRange,
        type: "array"
      }),
      postprice = "";

    if (value[1] === this.props.priceRangeSettings.max) plus = "+";

    postprice = (
      <span className="postlabel">
        :
        <strong>
          {" " +
            value[0] +
            "-" +
            value[1] +
            plus +
            " " +
            this.props.currency.code}
        </strong>
      </span>
    );

    return (
      <div>
        {title}
        {postprice}
      </div>
    );
  };

  priceRangeFormat = params => {
    if (!params.value && params.type !== "range") return null;

    var format = null;

    if (typeof params.value === "string")
      params.value = params.value.replace(/%7E/gi, "~").replace(/%3E/gi, ">");

    switch (params.type) {
      case "url":
        if (
          typeof params.min !== "undefined" &&
          typeof params.max !== "undefined" &&
          params.value[0] === params.min &&
          params.value[1] === params.max
        ) {
          // remains null
        } else {
          format = params.value[0] + "~";

          if (params.value[1] >= this.props.priceRangeSettings.max)
            format += ">";

          format += params.value[1];
        }

        break;

      case "array":
        if (params.value && params.value.indexOf("~") !== -1) {
          var split = params.value.split("~");
          format = [parseInt(split[0]), parseInt(split[1].replace(/\D/g, ""))];
        } else {
          format = [params.value[0], params.value[1]];
        }
        break;

      case "range":
        format = [];
        if (params.from) {
          for (
            var i = this.props.priceRangeSettings.min;
            i <= this.props.priceRangeSettings.max;
            i += this.props.priceRangeSettings.step
          ) {
            format.push({
              value: i,
              display: CurrencyData[this.props.currency.code] + i
            });
          }
        } else if (params.to) {
          for (
            var i = this.props.priceRangeSettings.step;
            i <= this.props.priceRangeSettings.max;
            i += this.props.priceRangeSettings.step
          ) {
            format.push({
              value: i,
              display: CurrencyData[this.props.currency.code] + i
            });
          }

          format.push({
            value: ">" + this.props.priceRangeSettings.max,
            display:
              ">" +
              CurrencyData[this.props.currency.code] +
              this.props.priceRangeSettings.max
          });
        }
        break;

      default:
        break;
    }

    return format;
  };

  reset = () => {
    const { r } = this.props;
    if (this.props.updateURL) {
      this.loading(true);
      fetch(r("search-reset")).then(data => {
        this.setState({
          queryObject: {},
          queryString: ""
        });
        this.props.onChange("");
        this.props.onPageChange(1);
        if (this.props.updateURL) {
          additionalfn.updateURL({
            r: r,
            query: "",
            sort: null,
            page: null
          });
        }

        this.getFields({ queryString: "" });
      });
    } else {
      window.location.href = r("search-reset");
    }
  };

  showLabel() {
    const { t, mobile, queryResult } = this.props;

    let totalResultsCount = this.state && this.state.totalResultsCount ? this.state.totalResultsCount : queryResult.totalResultsCount;
    const countLabel  = '(' + totalResultsCount + ')';
    return (
        <span>
          {mobile ? t("showvillas") : t("show")}
          <small className="ml-1 valign-bottom">
          { totalResultsCount && countLabel}
          </small>
        </span>
      );
  }

  submit = () => {
    if (
      this.props.updateURL &&
      !this.props.hideResults &&
      !this.props.searchURLbase
    ) {
      // scroll to search results
      const element = document.getElementById("SearchResults");
      const yCoordinate =
        element.getBoundingClientRect().top + window.pageYOffset;

      if (
        this.props.initial_query === "search_viewed" ||
        this.props.initial_query === "search_favourite" ||
        window.location.href.indexOf("/favourite") !== -1 ||
        window.location.href.indexOf("/viewed") !== -1
      ) {
        this.onChange({ items: [] });
        window.scrollTo({
          top: yCoordinate,
          behavior: "smooth"
        });
      } else {
        window.scrollTo({
          top: yCoordinate,
          behavior: "smooth"
        });
      }

      var event = new CustomEvent("SearchFrame_submit");

      document.dispatchEvent(event);
    } else {
      const { r } = this.props;
      if (this.state.queryString === "") {
        const query = "page/1";
        var route = r("search", { query });
      } else {
        const query = this.state.queryString;
        var route = r("search", { query });
      }

      window.location.href = route;
    }
  };
  getInitialFields = () => {
    const { t, r, open, poolWithPrivacyEnabled, searchFormVariant } = this.props;
    const iconColor = (searchFormVariant === "white") ? "blue1" : "blue3";
    const poolWithPrivacyRef = poolWithPrivacyEnabled ? this.poolWithPrivacyRef : null;
    const YoungsterTooltip = (
      <span>
        <Tooltip
          className="inline-block valign-middle ml-1 relative"
          maxWidth="250px"
          position="top"
          html={
            <img
              src={
                this.state.iconURL +
                "/assets/img/front/icons/info-circle-orange2.svg"
              }
              width="15"
              height="15"
              alt="info"
            />
          }
          show={t("youngsters_title")}
        />
      </span>
    );
    
    const PoolWithPrivacyTooltip = (
        <Tooltip
          className="inline-block valign-middle ml-1 relative"
          maxWidth="200px"
          position="top"
          html={
            <img
              src={
                this.state.iconURL +
                "/assets/img/front/icons/info-circle-orange2.svg"
              }
              width="15"
              height="15"
              alt="info"
            />
          }
          show={t("pool_with_privacy_info")}
        />
    );

    let fields = {};
    let priceRangeLabel = this.priceRangeLabel();

    fields.modal = this.state.modal;
    let regionValue = this.state.queryObject.region ? this.state.queryObject.region : ( this.props.queryString ? this.queryTokenize({queryString: this.props.queryString}).region : '' );
    fields.region = (
      <div>
        <div>
            <Select
            id="search_region"
            value={regionValue}
            clearable={true}
            clearOffsetRight="2.5rem"
            className={"select width-100"}
            disabled={this.state.loading}
            onChange={value => this.onChange({ items: { region: value, city: null } })}
            placeholder={t("choose_region")}
            autocomplete={true}
            options={this.state.regionOptions ? this.state.regionOptions : this.getDefaultRegionChoices()}
            withIcon={true}
            iconSrc={
              this.state.iconURL + "/assets/img/front/icons/planet-" + iconColor + ".svg"
            }
            searchFormVariant={searchFormVariant}
          />
          <RegionInfoIcon className="" onClick={this.toggleMap}>
            <img src={this.state.iconURL + "/assets/img/front/icons/info-circle-orange2.svg"} width="20" height="20" alt="info"/>
          </RegionInfoIcon>
        </div>
        {this.state.mapOpen &&
          <MapPopup>
            <MapContainer className="absolute border-radius-default bg-white" onClick={event => { this.setState({mapOpen: false})}} >
              <MapImage className="border-radius-default" src="https://www.clubvillamar.com/assets/img/front/map.jpg"  />
            </MapContainer>
          </MapPopup>
        }
      </div>
    );

    // fields.country = (
    //   <Select
    //     value={this.state.queryObject.country}
    //     disabled={this.state.loading}
    //     clearable={true}
    //     onChange={value => this.onChange({ items: { country: value } })}
    //     placeholder={t("where_to_go")}
    //     options={this.state.countryOptions ? this.state.countryOptions : []}
    //     withIcon={true}
    //     className="select width-100"
    //     iconSrc={
    //       this.state.iconURL +
    //       "/assets/img/front/icons/marker-location-blue3.svg"
    //     }
    //   />
    // );

    let stayStartValue = this.state.queryObject.stayStart ? this.state.queryObject.stayStart : ( this.props.queryString ? this.queryTokenize({queryString: this.props.queryString}).stayStart : null );
    let stayEndValue = this.state.queryObject.stayEnd ? this.state.queryObject.stayEnd : ( this.props.queryString ? this.queryTokenize({queryString: this.props.queryString}).stayEnd : null );
    fields.dates = (
      <DatepickerRange
        locale={this.props.locale}
        mobile={this.props.mobile}
        disabled={this.state.loading}
        clearable={true}
        startDatePlaceholderText={t("arrival_date")}
        startDate={stayStartValue}
        endDatePlaceholderText={t("departure_date")}
        endDate={stayEndValue}
        arrivalOffset={this.props.arrivalOffset}
        numberOfMonths={this.props.mobile ? 18 : 2}
        withIcon={true}
        iconSrc={
          this.state.iconURL + "/assets/img/front/icons/calendar-" + iconColor + ".svg"
        }
        onChangeStartDate={stayStart =>
          this.onChange({ items: { stayStart: stayStart, stayEnd: null } })
        }
        onChangeEndDate={stayEnd =>
          this.onChange({ items: { stayEnd: stayEnd } })
        }
        searchFormVariant={searchFormVariant}
      />
    );

    let maxSleepsValue = this.state.queryObject.maxSleeps ? this.state.queryObject.maxSleeps : ( this.props.queryString ? this.queryTokenize({queryString: this.props.queryString}).maxSleeps :  false);
    if (!this.props.maxSleepsType || this.props.maxSleepsType === "Counter") {
      fields.maxSleeps = (
        <Counter
          mobile={this.props.mobile}
          clearable={true}
          disabled={this.state.loading}
          count={maxSleepsValue}
          min={0}
          onChange={count =>
            this.onChange({ items: { maxSleeps: count }, rule: "not_zero" })
          }
          placeholder={t("guests")}
          placeholderSingular={t("guest")}
          inlineDisplay={false}
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/people-two-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );
    } else {
      fields.maxSleeps = (
        <Select
          id="search_maxSleeps"
          value={maxSleepsValue}
          disabled={this.state.loading}
          clearable={true}
          onChange={value =>
            this.onChange({ items: { maxSleeps: value }, rule: "not_zero" })
          }
          placeholder={t("guests")}
          options={
            this.state.maxSleepsOptions ? this.state.maxSleepsOptions : this.getDefaultMaxSleepsChoices()
          }
          withIcon={true}
          className={"select" + (searchFormVariant === 'white' ? " border-radius-default bor-thin bor-blue1 bor-solid" : "")}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/people-two-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );
    }

    fields.submit = (
      <button
        onClick={this.submit}
        className={"btn btn-secondary uppercase btn-block" + (searchFormVariant !== 'white' ? " bor-no" : "")}
      >
        {this.state.searchLabel}
      </button>
    );

    fields.reset = this.reset;
    if (open) {
      fields.numBedrooms = (
        <Counter
          mobile={this.props.mobile}
          clearable={true}
          disabled={this.state.loading}
          count={
            this.state.queryObject.numBedrooms
              ? this.state.queryObject.numBedrooms
              : false
          }
          min={0}
          max={this.state.numBedrooms ? this.state.numBedrooms.max : false}
          onChange={count =>
            this.onChange({ items: { numBedrooms: count }, rule: "not_zero" })
          }
          placeholder={t("bedrooms")}
          placeholderSingular={t("bedroom")}
          inlineDisplay={false}
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/bed-side-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.numBathrooms = (
        <Counter
          mobile={this.props.mobile}
          clearable={true}
          disabled={this.state.loading}
          count={
            this.state.queryObject.numBathrooms
              ? this.state.queryObject.numBathrooms
              : false
          }
          min={0}
          max={this.state.numBathrooms ? this.state.numBathrooms.max : false}
          onChange={count =>
            this.onChange({ items: { numBathrooms: count }, rule: "not_zero" })
          }
          placeholder={t("bathrooms")}
          placeholderSingular={t("bathroom")}
          inlineDisplay={false}
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/bathroom-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.poolType = (
        <Select
          id="search_poolType"
          value={this.state.queryObject.poolType}
          clearable={true}
          className="select"
          disabled={this.state.loading}
          onChange={(value) => { this.onChange({ items: { poolType: value, poolWithPrivacy: (value != 'private' || !poolWithPrivacyEnabled) ? null : this.state.queryObject.poolWithPrivacy }}); if( value != 'private' && poolWithPrivacyEnabled) { poolWithPrivacyRef.current.unCheck()}}}
          placeholder={t("pooltype")}
          options={this.state.poolOptions ? this.state.poolOptions : []}
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/pool-lader-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );
      fields.seaView = (
        <div className="flex items-center">
          <CheckBox
            id="search_seaView"
            value={this.state.queryObject.seaView}
            disabled={
              this.state.loading
                ? true
                : this.state.seaView === true
                ? true
                : false
            }
            onChange={value => this.onChange({ items: { seaView: value } })}
            label={t("seaview")}
          />
        </div>
      );
      if (poolWithPrivacyEnabled) {
      fields.poolWithPrivacy = (
        <div className="flex items-center">
          <CheckBox
          id="search_poolWithPrivacy" 
          ref={this.poolWithPrivacyRef}
          value={this.state.queryObject.poolWithPrivacy}
          disabled={
            this.state.loading
              ? true
              : this.state.poolWithPrivacy === true
              ? true
              : false
          }
          onChange={value => this.onChange({ items: { poolWithPrivacy: value, poolType: value ?  'private' : this.state.queryObject.poolType ?  this.state.queryObject.poolType : null } })}
          label={t("pool_with_privacy")}
         />
          <div>{PoolWithPrivacyTooltip}</div>
        </div>
      );
      }
      fields.accommodationType = (
        <Select
          id="search_accommodationType"
          value={this.state.queryObject.accommodationType}
          clearable={true}
          className="select"
          disabled={this.state.loading}
          onChange={value =>
            this.onChange({ items: { accommodationType: value } })
          }
          placeholder={t("accomodationtype")}
          options={
            this.state.accommodationOptions
              ? this.state.accommodationOptions
              : []
          }
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/house-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.city = (
        <Select
          id="search_city"
          value={this.state.queryObject.city}
          clearable={true}
          className="select"
          disabled={this.state.loading}
          onChange={value => this.onChange({ items: { city: value }})}
          placeholder={t("selectcity")}
          autocomplete={true}
          options={this.state.cityOptions ? this.state.cityOptions : []}
          withIcon={true}
          iconSrc={
            this.state.iconURL +
            "/assets/img/front/icons/street-signals-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.distanceBeach = (
        <Select
          id="search_distanceBeach"
          value={this.state.queryObject.distanceBeach}
          clearable={true}
          className="select"
          disabled={this.state.loading}
          onChange={value => this.onChange({ items: { distanceBeach: value } })}
          placeholder={additionalfn.jsUcfirst(t("distancetobeach"))}
          options={this.state.beachOptions ? this.state.beachOptions : []}
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/beach-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.villaname = (
        <Select
          id="search_villaname"
          value={null}
          disabled={this.state.loading}
          onChange={value => {
            window.location.href = value;
          }}
          placeholder={additionalfn.jsUcfirst(t("villa_name"))}
          options={[]}
          withIcon={true}
          autocomplete={true}
          autocompleteTriggerURL={r("search_suggest") + "?q="}
          autocompleteTriggerKey="url"
          autocompleteTriggerLabel="name"
          iconSrc={
            this.state.iconURL +
            "/assets/img/front/icons/magnifying-glass-" + iconColor + ".svg"
          }
          searchFormVariant={searchFormVariant}
        />
      );

      fields.youngstersAllowed = (
        <div className="flex items-center">
          <CheckBox
            id="search_youngstersAllowed"
            value={this.state.queryObject.youngstersAllowed}
            disabled={
              this.state.loading
                ? true
                : this.state.youngstersAllowed === true
                ? true
                : false
            }
            onChange={value =>
              this.onChange({ items: { youngstersAllowed: value } })
            }
            label={t("youngstersallowed")}
          />
          <span>{YoungsterTooltip}</span>
        </div>
      );

      fields.internet = (
        <CheckBox
          id="search_internet"
          value={this.state.queryObject.internet}
          disabled={
            this.state.loading
              ? true
              : this.state.internet === true
              ? true
              : false
          }
          onChange={value => this.onChange({ items: { internet: value } })}
          label={t("internetavailable")}
        />
      );

      fields.airConditioning = (
        <CheckBox
          id="search_airConditioning"
          value={this.state.queryObject.airConditioning}
          disabled={
            this.state.loading
              ? true
              : this.state.airConditioning === true
              ? true
              : false
          }
          onChange={value =>
            this.onChange({ items: { airConditioning: value } })
          }
          label={t("airconditioning")}
        />
      );

      fields.dishwasher = (
        <CheckBox
          id="search_dishwasher"
          value={this.state.queryObject.dishwasher}
          disabled={
            this.state.loading
              ? true
              : this.state.dishwasher === true
              ? true
              : false
          }
          onChange={value => this.onChange({ items: { dishwasher: value } })}
          label={t("dishwasher")}
        />
      );

      fields.washingMachine = (
        <CheckBox
          id="search_washingMachine"
          value={this.state.queryObject.washingMachine}
          disabled={
            this.state.loading
              ? true
              : this.state.washingMachine === true
              ? true
              : false
          }
          onChange={value =>
            this.onChange({ items: { washingMachine: value } })
          }
          label={t("washingmachine")}
        />
      );

      fields.petsAllowed = (
        <CheckBox
          id="search_petsAllowed"
          value={this.state.queryObject.petsAllowed}
          disabled={
            this.state.loading
              ? true
              : this.state.petsAllowed === true
              ? true
              : false
          }
          onChange={value => this.onChange({ items: { petsAllowed: value } })}
          label={t("petsallowed")}
        />
      );
    }
    if (
      this.props.priceRangeSettings &&
      this.state.queryObject &&
      this.state.queryObject.stayStart &&
      this.state.queryObject.stayEnd
    ) {
      fields.priceRange = this.props.mobile ? (
        <ScrollerMobiscroll
          value={this.priceRangeFormat({
            value: this.state.queryObject.priceRange,
            type: "array"
          })}
          fromValues={this.priceRangeFormat({ type: "range", from: true })}
          separator=" ~ "
          toValues={this.priceRangeFormat({ type: "range", to: true })}
          disabled={this.state.loading}
          validateRule=">=+"
          placeholder={t("select_price_range")}
          onChange={value =>
            this.onChange({
              items: {
                priceRange: this.priceRangeFormat({
                  value: value,
                  type: "url",
                  min: this.props.priceRangeSettings.min,
                  max: this.props.priceRangeSettings.max
                })
              }
            })
          }
          labels={{
            from: additionalfn.jsUcfirst(t("calendar.from")),
            to: additionalfn.jsUcfirst(t("calendar.to")),
            select: additionalfn.jsUcfirst(t("select")),
            cancel: additionalfn.jsUcfirst(t("cancel")),
            clear: additionalfn.jsUcfirst(t("clear"))
          }}
          displayType="bottom"
          className="text-left bg-white bor-white btn select"
          withIcon={true}
          iconSrc={
            this.state.iconURL + "/assets/img/front/icons/dollar-" + iconColor + ".svg"
          }
        />
      ) : (
        <SliderMobiscroll
          value={this.priceRangeFormat({
            value: this.state.queryObject.priceRange,
            type: "array"
          })}
          min={this.props.priceRangeSettings.min}
          onChange={value =>
            this.onChange({
              items: {
                priceRange: this.priceRangeFormat({
                  value: value,
                  type: "url",
                  min: this.props.priceRangeSettings.min,
                  max: this.props.priceRangeSettings.max
                })
              }
            })
          }
          max={this.props.priceRangeSettings.max}
          step={this.props.priceRangeSettings.step}
          label={priceRangeLabel}
          clearable={true}
          searchFormVariant={searchFormVariant}
        />
      );
    }
    return fields;
  };

  render() {
    const fields = this.getInitialFields();

    return this.props.renderForm(fields);
  }
}

export const SearchFrame = compose(
  withTranslator,
  withFosRouter
)(SearchFrameComponent);
